import InsureProcessSuccess from './InsureProcessSuccess';
export default InsureProcessSuccess;
